import React from 'react';
import './CookiesPopup.scss'


const CookiesPopup = ({ handleClose ,data}) => {

    const closeCookiePopup =()=>{
        localStorage.setItem('cookie-accepted', true);
        handleClose()
    }

    return (<>
        <div className="container-cookie-popup" id="showCookiePopup">
            <div className="col-sm-12 cls-flex">
                <div >
                    <div className="title" >{data?.title}</div>
                    <p className="details cookie-new-css">{data?.description}</p>
                </div>
                <div>
                    <div className="btn-section btn-section-2">
                        <a className="accept-btn btn btn-css-new"
                            onClick={closeCookiePopup}>{data?.actionText}</a>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default CookiesPopup;